document.addEventListener('DOMContentLoaded', () => {
  const containersIso = document.querySelectorAll('.c-cta--iso, .c-cta--iso-heading-only');

  containersIso.forEach(containerIso => {
    containerIso.addEventListener('mouseover', event => {
      if (event.target.classList.contains('c-link--btn') && event.target.closest('.c-cta')) {
        event.target.closest('.c-cta').classList.add('is-hovered');
      }
    });

    containerIso.addEventListener('mouseout', event => {
      if (event.target.classList.contains('c-link--btn') && event.target.closest('.c-cta')) {
        event.target.closest('.c-cta').classList.remove('is-hovered');
      }
    });
  });
});
